import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const BOX_STYLE_DEFAULT = {
    width: "100%",
    height: "auto",
    // minHeight: { xs: "50px", sm: "50px", md: "auto" },
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
};

const TYPOGRAPHY_STYLE_DEFAULT = {
    textAlign: "center",
    fontWeight: "bold",
};

interface NoDataProps {
    message: string;
    boxStyle?: object;
    typographyStyle?: object;
}

const NoData = (props: NoDataProps) => {
    const boxStyle = Object.assign(BOX_STYLE_DEFAULT, props.boxStyle);
    const typographyStyle = Object.assign(TYPOGRAPHY_STYLE_DEFAULT, props.typographyStyle);
    return (
        <Box sx={boxStyle}>
            <Typography variant="body1" sx={typographyStyle}>
                {props.message}
            </Typography>
        </Box>
    );
};

export default NoData;
